import DatePicker, { registerLocale } from "react-datepicker";
import th from 'date-fns/locale/th';
import "react-datepicker/dist/react-datepicker.css";
import { Controller } from "react-hook-form";
import { Icon, Input, InputGroup, InputLeftElement } from "@chakra-ui/react";
import { BsCalendar } from "react-icons/bs";
import { forwardRef } from "react";
registerLocale('th', th)

const CustomInput = forwardRef(({ value, onClick }, ref) =>
    <InputGroup>
        <InputLeftElement
            pointerEvents="none"
            children={<Icon as={BsCalendar} color="gray.300" />}
            zIndex={0}
        />
        <Input placeholder="เลือกวันและเวลา" onClick={onClick} value={value} ref={ref} />
    </InputGroup>)

const InputDatePicker = ({ control, name, required = true, showTimeInput=true , defaultValue = new Date()}) => {
    return (
        <Controller
            name={name}
            defaultValue={defaultValue}
            control={control}
            rules={{ required: required }}
            render={({ field: { value, onChange } }) =>
                <DatePicker locale="th"
                    customInput={<CustomInput />}
                    selected={value}
                    onChange={onChange}
                    isClearable={true}
                    shouldCloseOnSelect={false}
                    showTimeInput={showTimeInput}
                    timeFormat={showTimeInput ? "HH:mm": ""}
                    dateFormat={showTimeInput ? "dd/MM/yyyy HH:mm น.":"dd/MM/yyyy"} />}
        />
    )
}

export default InputDatePicker
